var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPattern2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71217 13.9459L4.29006 23.5388L8.64288 25.9991L14.065 16.4062L23.658 21.8283L26.1183 17.4755L16.5253 12.0533L21.9474 2.46029L17.5946 0L12.1725 9.59306L2.57943 4.17092L0.119141 8.52373L9.71217 13.9459Z",
    fill: "url(#paint0_linear_42_1711)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_1711",
    x1: 1.65615,
    y1: 25.9991,
    x2: 29.2715,
    y2: 22.2119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EA5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD1D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern2);
export default __webpack_public_path__ + "static/media/pattern-2.a80a09f3391191f798747f4d585a26e0.svg";
export { ForwardRef as ReactComponent };